<template>
    <!-- 在线咨询按钮 -->
    <div class="components">
        <div class="ask row_center" @click="showPopup">在线咨询</div>
        <!-- 在线咨询 -->
        <div class="msg_popup">
            <van-popup v-model="show" closeable>
                <div class="p_content">
                    <mslMsg @finish="show = $event"></mslMsg>
                </div>
            </van-popup>
        </div>
    </div>

</template>

<script>
    export default {
        name: "onlineBtn",
        data() {
            return {
                show: false,
            }
        },
        methods: {
            showPopup() {
                this.show = true;
            }
        }
    }
</script>
<style scoped lang="scss">
    .ask {
        width: 89px;
        height: 34px;
        border: 1px solid #262626;
        border-radius: 2px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        line-height: 20px;
        color: #262626;
    }
    .msg_popup {
        /* 在线咨询弹窗 */
        &::v-deep {
            .van-popup {
                border-radius: 4px;
            }
        }
        .p_content {
            width: 343px;
            box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06);
            border-radius: 4px;
        }
    }
</style>
